// //             <div class="add-text">
// <img src="@/static/images/payment/address_icon.png" alt="zeelool glasses"/>
// <span>Add New Address</span>
// </div>
// <i class="iconfont icon-xiangyou1"></i>

import Image from '@/components/Image';
import { RightArrowOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';

export default function WithoutAddressPreview({ onClick }: { onClick: () => void }) {
  const t = useTranslations('payment.BillingAddress');

  return (
    <div className="flex items-center justify-between" onClick={onClick}>
      <div className="flex items-center justify-start flex-1">
        <Image src="/payment/address_icon.png" alt="add-new-address" width={30} height={30} />
        <h3 className="text-[16px] font-bb ml-10">{t('addNewAddress')}</h3>
      </div>
      <RightArrowOutlined />
    </div>
  );
}
